/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import React from 'react';

import notifications from 'notifications';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as TrayTaskActions from 'tray/TrayTaskActions';
import * as TrayTaskConstants from 'tray/TrayTaskConstants';

import TFIDAO from './TFIDAO';

const TFIFileImport = {};

function onUploadFailed(taskId, response) {
  notifications.notifyError(response);
  const error = 'An error occurred while uploading the file. Please try again.';
  TrayTaskActions.updateTrayTask(taskId, {progress: TrayTaskConstants.FAILURE_PROGRESS, error});
}

function importForNote(noteId, tfiObject, taskId) {
  return TFIDAO.importFile({
    accountId: tfiObject.accountId,
    fileId: tfiObject.id,
    fileName: tfiObject.name,
  })
    .progress((progress) => {
      TrayTaskActions.updateTrayTask(taskId, {progress});
    })
    .then(({noteLinkedObject}) => {
      if (noteLinkedObject != null) {
        return noteLinkedObject;
      } else {
        notifications.error('File has been removed');
        return $.Deferred().reject().promise();
      }
    })
    .done((noteLinkedObject) => {
      if (taskId != null) {
        TrayTaskActions.updateTrayTask(taskId, {
          progress: TrayTaskConstants.SUCCESS_PROGRESS,
          duration: 5,
        });
      }
    })
    .fail(notifications.notifyError);
}

TFIFileImport.createTaskAndImportFile = function (noteId, tfiObject) {
  const taskId = TrayTaskActions.createTrayTask({
    icon: <BenchlingIcon icon="paperclip" />,
    heading: tfiObject.name,
  });
  const fileUploadDeferred = importForNote(noteId, tfiObject, taskId).fail(onUploadFailed.bind(null, taskId));
  return {taskId, fileUploadDeferred};
};

TFIFileImport._importForNote = importForNote;
export default TFIFileImport;
